module.exports = __webpack_public_path__ + "img/纵深精工.e15f5522.e15f5522.jpg";